import { render, staticRenderFns } from "./CmsImage.vue?vue&type=template&id=97cfaf68&"
import script from "./CmsImage.vue?vue&type=script&lang=js&"
export * from "./CmsImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports